<div class="app-navbar__container app-page-container">
  <a
    class="app-navbar__logo-container hover-cursor-pointer"
    [class.--blocked]="isNavigationBlocked"
    (click)="_onToMainPageClick()">
    <img
      class="app-navbar-logo"
      [src]="logoState.headerLogo$ | async" />
  </a>

  <div
    class="app-navbar__nav-item --tester b3-r"
    #navItemTester></div>

  <nav
    class="app-navbar__nav"
    [class.--blocked]="isNavigationBlocked"
    #nav>
    <div class="app-navbar__nav-body">
      @for (navbarItem of navbarItems$ | async; track navbarItem) {
        <a
          [routerLink]="[navbarItem.url]"
          routerLinkActive="c1-m"
          (isActiveChange)="changeActiveNavItem($event, navbarItem)"
          #rla="routerLinkActive"
          [class.c-base]="rla.isActive"
          [class.c-65]="!rla.isActive"
          class="app-navbar__nav-item b3-r">
          @if (navbarItem.badge; as badge) {
            <span class="app-navbar__label">
              <app-badge [variant]="badge.color">{{ badge.text | translate }}</app-badge>
              <span class="app-navbar__label-text">{{ navbarItem.name | translate }}</span>
            </span>
          } @else {
            {{ navbarItem.name | translate }}
          }
        </a>
      }
    </div>
  </nav>

  @let _popupNavbarItems = popupNavbarItems$ | async;

  <nav class="app-navbar__nav-right">
    @if (_popupNavbarItems.length) {
      <div
        class="app-navbar__nav-item --icon"
        [class.--blocked]="isNavigationBlocked">
        <app-svg
          [icon]="'MenuVertical_24'"
          [matMenuTriggerFor]="menu"
          class="app-navbar__nav__big-icon">
        </app-svg>

        <mat-menu #menu="matMenu">
          @for (popupNavbarItem of _popupNavbarItems; track popupNavbarItem) {
            <a
              mat-menu-item
              [routerLink]="[popupNavbarItem.url]"
              class="b3-r"
              routerLinkActive="c1-m"
              (isActiveChange)="changeActiveNavItem($event, popupNavbarItem)"
              #rla="routerLinkActive">
              <span [routerLink]="popupNavbarItem.url">
                @if (popupNavbarItem.badge; as badge) {
                  <span class="app-navbar__label">
                    <app-badge [variant]="badge.color">{{ badge.text | translate }}</app-badge>
                    <span class="app-navbar__label-text">{{
                      popupNavbarItem.name | translate
                    }}</span>
                  </span>
                } @else {
                  {{ popupNavbarItem.name | translate | titlecase }}
                }
              </span>

              @if (rla.isActive) {
                <app-svg
                  [icon]="'Done_24'"
                  style="margin-left: auto">
                </app-svg>
              }
            </a>
          }
        </mat-menu>
      </div>
    }

    @if (userpilotService.isUserpilotEnabled$ | async) {
      <div class="app-navbar__nav-item --icon">
        <app-svg
          id="app-help-center-icon"
          [icon]="'Question24'"
          [disabledHover]="true"
          class="hover-cursor-pointer">
        </app-svg>
      </div>
    }

    @if (layoutState.showNotifications$ | async) {
      @let _count = notificationsService.pushNotificationsCount$ | async;

      <a
        class="app-navbar__nav-item --icon"
        (click)="_onShowNotificationsClick()"
        [matTooltip]="
          _count > 0 ? 'Unread notifications: ' + _count : ('tooltip.notifications' | translate)
        "
        matTooltipShowDelay="300">
        <app-svg
          class="hover-cursor-pointer app-navbar__notification-icon"
          [type]="'none'"
          [disabledHover]="true"
          [icon]="_count > 0 ? 'NotificationUnread' : 'Notification'">
        </app-svg>
      </a>
    }

    <a
      [matTooltip]="'tooltip.user-settings' | translate"
      matTooltipShowDelay="300"
      class="app-navbar__nav-item app-navbar__nav-item--without-underline pr-0--imp"
      (click)="_onProfileMenuClick(profileNavItemElement)"
      #profileNavItemElement>
      <app-svg
        [icon]="'User_24'"
        class="hover-cursor-pointer"
        [disabledHover]="true">
      </app-svg>
    </a>
  </nav>
</div>
